import FAQComponent from "../components/FAQ";
import Reveal from "../components/Reveal";
import { whatsappLink } from "../data/site";
import { WhatsAppIcon } from "../components/Illustrations";

export default function FAQPage() {
  return (
    <div className="pt-28" data-testid="faq-page">
      <section className="px-5 md:px-10 pb-6">
        <div className="mx-auto max-w-[1100px] text-center">
          <Reveal><p className="eyebrow mb-4">Help &amp; questions</p></Reveal>
          <Reveal delay={60}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[112px] leading-[0.95] tracking-[-0.03em]">
              All your <span className="italic">little questions.</span>
            </h1>
          </Reveal>
        </div>
      </section>
      <FAQComponent />
      <section className="px-5 md:px-10 py-20 bg-[#F3EADA]">
        <div className="mx-auto max-w-[800px] text-center">
          <h2 className="font-serif text-3xl md:text-5xl leading-[1.1] tracking-[-0.02em]">
            Can't find what you're looking for?
          </h2>
          <p className="mt-4 text-[#595955] text-lg">Drop us a WhatsApp — we usually reply within an hour.</p>
          <a href={whatsappLink()} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white px-7 py-4 text-[15px] font-medium hover:brightness-95 transition-all" data-testid="faq-whatsapp-cta">
            <WhatsAppIcon /> Chat on WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
}
